import React, { FC } from 'react';

import { cn } from '../lib/utils';
import Typography from '../Typography/Typography';
import { UILabel, UIRadioGroupItem } from '../ui';

export type RadioButtonOptionsProps = {
  dataTestId?: string;
  value: string;
  label?: string;
  id?: string;
};

export type RadioButtonProps = React.ComponentProps<typeof UIRadioGroupItem> &
  RadioButtonOptionsProps & {
    description?: string;
    className?: string;
    selectedColor?: string;
  };

const RadioButton: FC<RadioButtonProps> = ({
  value,
  label,
  id,
  description,
  dataTestId,
  className,
  selectedColor
}) => {
  return (
    <div
      className={cn(
        'flex items-center',
        description && 'items-start',
        className
      )}
      data-testid={dataTestId}
    >
      <UIRadioGroupItem
        className={cn(
          'h-5 w-5 border-2 border-base-border shadow-none',
          '[&>span>svg]:h-3 [&>span>svg]:w-3',
          '[&>span>svg]:!border-0 [&>span>svg]:!stroke-0 [&>span>svg]:!outline-0',
          '[&>span>svg>circle]:!stroke-0 [&>span>svg>circle]:!border-0',
          !selectedColor && '[&[data-state=checked]>span>svg]:fill-indigo-600',
          selectedColor === 'primary' && '[&[data-state=checked]>span>svg]:fill-base-primary [&[data-state=checked]]:border-base-primary',
          description && 'mt-1'
        )}
        value={value}
        id={id}
      />
      {label && (
        <div className="ml-2 ">
          <UILabel
            className="text-p-s text-base-foreground mb-1 !cursor-pointer"
            htmlFor={id}
          >
            {label}
          </UILabel>
          {description && (
            <Typography className="text-p-s text-base-mutedForeground">
              {description}
            </Typography>
          )}
        </div>
      )}
    </div>
  );
};

export default RadioButton;
